'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _CheckCircleFilled = _interopRequireDefault(require('./lib/icons/CheckCircleFilled'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _CheckCircleFilled;
exports.default = _default;
module.exports = _default;